import { AIRequestType } from '../ChatWindow';

const TAI_BASE_URL = process.env.NEXT_PUBLIC_TAI_BASE_URL;
const TAI_PATH = '/api/v1';

export enum TAIEndpoint {
  Query = 'query',
  Summarize = 'summarize',
  SummarizePdf = 'summarize-pdf',
  AnalyzeImage = 'analyze-image',
}

export const AI_ENDPOINTS = {
  query: `${TAI_BASE_URL}${TAI_PATH}/${TAIEndpoint.Query}`,
  summarize: `${TAI_BASE_URL}${TAI_PATH}/${TAIEndpoint.Summarize}`,
  summarizePdf: `${TAI_BASE_URL}${TAI_PATH}/${TAIEndpoint.SummarizePdf}`,
  analyzeImage: `${TAI_BASE_URL}${TAI_PATH}/${TAIEndpoint.AnalyzeImage}`,
};

export async function buildRequestBody({type, data, query, fingerprint}: {type: AIRequestType, data: any, query: string, fingerprint?: string}): Promise<any> {
      let response: Response;
      switch (type) {
        case AIRequestType.GeneralQuery:
          response = await fetch(AI_ENDPOINTS.query, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              userQuery: query,
              sessionId: data.sessionId,
              tourId: data.tourId,
              tourSlug: data.tourSlug,
              position: data.position,
              cameraCorners: data.cameraCorners,
              userId: fingerprint || undefined,
            }),
          });
          break;

        case AIRequestType.TextSummarize:
          response = await fetch(AI_ENDPOINTS.summarize, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              text: data.text,
              query: query,
              sessionId: data.sessionId,
              tourId: data.tourId,
              tourSlug: data.tourSlug,
              maxLength: data.maxLength || 500,
              language: data.language || 'English',
              position: data.position,
              cameraCorners: data.cameraCorners,
              userId: fingerprint || undefined,
            }),
          });
          break;

        case AIRequestType.PdfSummary:
          response = await fetch(AI_ENDPOINTS.summarizePdf, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              url: data.pdfUrl,
              tourId: data.tourId,
              tourSlug: data.tourSlug,
              sessionId: data.sessionId,
              maxLength: 500,
              language: 'English',
              position: data.position,
              cameraCorners: data.cameraCorners,
              userId: fingerprint || undefined,
            }),
          });
          break;

        default:
          throw new Error(`Unknown request type: ${type}`);
      }
      return response;
}
